export var defaultProps = {
    affix: true,
    getContainer: function () { return window; },
    className: '',
    offsetTop: 0,
    bounds: 5,
    type: 'vertical',
};
export var defaultAnchorLinkProps = {
    href: '#',
    className: 'anchor-item',
};
